module.exports = __webpack_public_path__ + "img/circlesRed.999b693.svg";